import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Header, Icon, Divider, Popup } from 'semantic-ui-react'

import { highlightManeuver, zoomToManeuver } from 'actions/directionsActions'
import { VALHALLA_OSM_URL } from 'utils/valhalla'

const COLOR_HEX = {
  green: '#3ecf8e',
  yellow: '#fbbf24',
  orange: '#f97316',
  red: '#ff6b6b',
  unavailable: '#d946ef',
  updated: '#3d8bfd',
}

const getLength = (length, unit) => {
  const visibleLength = length * 1000
  const displayUnit = unit === 'km' ? 'km' : 'mi'
  return (visibleLength / 1000).toFixed(2) + ' ' + displayUnit
}

class Maneuvers extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    legs: PropTypes.object.isRequired,
    idx: PropTypes.number.isRequired,
    header: PropTypes.string,
    profile: PropTypes.string,
    unit: PropTypes.string,
    results: PropTypes.object,
    trafficEnabled: PropTypes.bool,
  }

  highlightMnv = (sIdx, eIdx) => {
    const { dispatch, idx } = this.props
    dispatch(
      highlightManeuver({ startIndex: sIdx, endIndex: eIdx, alternate: idx })
    )
  }

  zoomToMnv = (sIdx) => {
    const { dispatch } = this.props
    dispatch(zoomToManeuver({ index: sIdx, timeNow: Date.now() }))
  }

  render() {
    const { legs, unit, idx, results, trafficEnabled } = this.props
    const traffic =
      trafficEnabled && results?.[VALHALLA_OSM_URL]?.trafficByRouteIndex?.[idx]

    const startIndices = {
      0: 0,
    }
    if (legs) {
      for (let i = 0; i < legs.length - 1; i++) {
        const endShapeIndex =
          legs[i].maneuvers[legs[i].maneuvers.length - 1].end_shape_index
        startIndices[i + 1] = endShapeIndex
      }
    }

    return (
      <React.Fragment>
        {legs &&
          legs.map((leg, i) =>
            leg.maneuvers.map((mnv, j) => {
              const trafficMnv = traffic?.legs?.[i]?.maneuvers?.[j]
              return (
                <React.Fragment key={`${i}-${j}`}>
                  <div
                    style={{ maxWidth: '320px' }}
                    className={'flex-column pt3 pb3 pointer'}
                    onMouseEnter={() =>
                      this.highlightMnv(
                        startIndices[i] + mnv.begin_shape_index,
                        startIndices[i] + mnv.end_shape_index
                      )
                    }
                    onMouseLeave={() =>
                      this.highlightMnv(
                        startIndices[i] + mnv.begin_shape_index,
                        startIndices[i] + mnv.end_shape_index
                      )
                    }
                    onClick={() =>
                      this.zoomToMnv(startIndices[i] + mnv.begin_shape_index)
                    }
                  >
                    <div className="pb2">
                      <Header as="h4">{mnv.instruction}</Header>
                    </div>
                    {mnv.type !== 4 && mnv.type !== 5 && mnv.type !== 6 && (
                      <div className={'flex justify-between'}>
                        <div
                          style={{
                            alignSelf: 'center',
                            flexBasis: '100px',
                          }}
                        >
                          <Icon
                            circular
                            name={'arrows alternate horizontal'}
                            size="small"
                          />
                          <div className={'dib pa1 f6'}>
                            {getLength(mnv.length, unit)}
                          </div>
                        </div>
                        <div
                          style={{
                            alignSelf: 'center',
                            flexGrow: 1,
                          }}
                        >
                          <Icon circular name={'time'} size="small" />
                          <div className={'dib pa1 f6'}>
                            {new Date(mnv.time * 1000)
                              .toISOString()
                              .substr(11, 8)}
                          </div>
                          {trafficMnv?.traffic?.time != null && (
                            <div
                              className={'dib pa1 f6'}
                              style={{
                                color: COLOR_HEX[trafficMnv.color] || '#9aa8bc',
                              }}
                            >
                              traffic{' '}
                              {new Date(trafficMnv.traffic.time * 1000)
                                .toISOString()
                                .substr(11, 8)}{' '}
                              {trafficMnv.delta?.timeHuman} (
                              {trafficMnv.delta?.timePctHuman})
                              {trafficMnv.traffic.lengthM != null && (
                                <span style={{ color: '#9aa8bc' }}>
                                  {' '}
                                  ·{' '}
                                  {(
                                    trafficMnv.traffic.lengthMiles ??
                                    trafficMnv.traffic.lengthM / 1609.344
                                  ).toFixed(2)}{' '}
                                  mi
                                </span>
                              )}
                              {trafficMnv.traffic.unavailable && (
                                <span> · unavailable</span>
                              )}
                              {trafficMnv.traffic.partial &&
                                !trafficMnv.traffic.unavailable && (
                                  <span style={{ color: '#9aa8bc' }}>
                                    {' '}
                                    · partial {trafficMnv.traffic.coveragePct}%
                                  </span>
                                )}
                            </div>
                          )}
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent:
                              mnv.toll && mnv.ferry
                                ? 'space-between'
                                : 'flex-start',
                            flexBasis: '80px',
                          }}
                        >
                          {mnv.toll && (
                            <div className={'flex align-center'}>
                              <Popup
                                content={'Toll'}
                                size={'tiny'}
                                offset={[-6, 0]}
                                trigger={
                                  <div>
                                    <Icon
                                      circular
                                      name={'dollar'}
                                      size="small"
                                    />
                                    <div className={'dib pa1 f6'}></div>
                                  </div>
                                }
                              />
                            </div>
                          )}
                          {mnv.ferry && (
                            <div className={'flex align-center'}>
                              <Popup
                                content={'Ferry'}
                                size={'tiny'}
                                offset={[-6, 0]}
                                trigger={
                                  <div>
                                    <Icon circular name={'ship'} size="small" />
                                    <div className={'dib pa1 f6'}></div>
                                  </div>
                                }
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  {mnv.type !== 4 && mnv.type !== 5 && mnv.type !== 6 && (
                    <Divider fitted />
                  )}
                </React.Fragment>
              )
            })
          )}
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  const { results } = state.directions
  const { trafficEnabled } = state.common
  return {
    results,
    trafficEnabled,
  }
}

export default connect(mapStateToProps)(Maneuvers)
